export default __webpack_public_path__ + "static/blog-img10-13b921bc8727c4dfea30915439dfa6fe.jpg";